import { getUser } from './getUser';
import { IAppState } from '../../common/state';

export function selectIsAgent(state: IAppState): boolean {
  const user = getUser(state);

  return !user.isAuthenticated ? false : user.isAgent && !user.isBuilder;
}
